export const READ_RECEIPT_ALLOWANCE_TYPES = {
  ALL: 'ALL',
  NONE: 'NONE',
  AGENTS_ONLY: 'AGENTS_ONLY',
};
